import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function CategoryGrid() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <p className="text-sm font-medium text-primary-600 mb-2">娱乐分类</p>
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
            多元化娱乐项目
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto">
            太阳娱乐为您提供丰富多样的娱乐选择，每一种分类都经过精心策划，确保您获得最优质的内容体验。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((cat) => {
            const colorMap: Record<string, { bg: string; text: string; iconBg: string }> = {
              primary: { bg: 'bg-primary-50 hover:bg-primary-100', text: 'text-primary-700', iconBg: 'bg-primary-100' },
              accent: { bg: 'bg-accent-50 hover:bg-accent-100', text: 'text-accent-700', iconBg: 'bg-accent-100' },
              secondary: { bg: 'bg-secondary-50 hover:bg-secondary-100', text: 'text-secondary-700', iconBg: 'bg-secondary-100' },
            };
            const colors = colorMap[cat.color] || colorMap.primary;

            return (
              <Link
                key={cat.slug}
                to={`/categories?tab=${cat.slug}`}
                className={`block p-6 rounded-xl transition-all duration-300 cursor-pointer ${colors.bg} group`}
              >
                <div className={`w-12 h-12 rounded-lg flex items-center justify-center mb-4 transition-colors ${colors.iconBg} group-hover:bg-background-50`}>
                  <i className={`${cat.icon} text-xl ${colors.text}`}></i>
                </div>
                <h3 className="text-lg font-semibold text-foreground-950 mb-2">{cat.name}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{cat.description}</p>
                <div className="mt-4 flex items-center gap-1 text-sm font-medium text-primary-600">
                  <span>了解更多</span>
                  <i className="ri-arrow-right-line text-xs"></i>
                </div>
              </Link>
            );
          })}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/categories"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-lg border-2 border-background-300 text-foreground-700 font-medium hover:border-primary-300 hover:text-primary-600 transition-all duration-300 text-sm"
          >
            查看全部分类
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}